import { ModBox, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { Dropdown } from '../Dropdown'
import { RadioButtonWithTitle } from '../RadioButtonWithTitle'
import { TextInputLabelToolTip } from '../TextInputLabelToolTip'
const getMdrList = (data: any) => {
  let mdrList = ''
  if (data?.feePkgName) {
    mdrList = data?.feePkgName
  }
  if (data?.feePkgName1) {
    mdrList = `${mdrList}|${data?.feePkgName1}`
  }
  if (data?.feePkgName2) {
    mdrList = `${mdrList}|${data?.feePkgName2}`
  }
  if (data?.schemeDetail) {
    mdrList = `${mdrList}|${data?.schemeDetail}`
  }
  if (data?.schemeDetail1) {
    mdrList = `${mdrList}|${data?.schemeDetail1}`
  }
  return mdrList
}
const FeePackageDetails = ({
  isEdit,
  getLovsFromKey,
  styles,
  setFieldValue,
  fieldName,
  isParentSelectedIsEntity,
}: any) => {
  const {
    fetchMdrPackageDetails,
    parentFeePackageDetails,
    emsParentEntityIdentificationNumber,
    showMdrFeePackage,
    updateBusinessDetail,
    inheritParentFeePackagePrefilled,
    mdrPackageIdPrefilled,
    mdrPackageDetailsPrefilled,
    globalSearchString,
  } = useStores((store) => ({
    fetchMdrPackageDetails: store.fetchMdrPackageDetails,
    parentFeePackageDetails: store.getMdrFeePackageDetails,
    emsParentEntityIdentificationNumber: store.onboarding.emsParentEntityIdentificationNumber,
    showMdrFeePackage: store.getIsParentEntityHasFeePackage,
    updateBusinessDetail: store.onboarding.updateBusinessDetail,
    mccCodePrefilled: store.onboarding.businessDetail.mccCode,
    businessLinePrefilled: store.onboarding.businessDetail.businessLine,
    businessCategoryPrefilled: store.onboarding.businessDetail.businessCategory,
    inheritParentFeePackagePrefilled: store.onboarding.businessDetail.inheritParentFeePackage,
    mdrPackageIdPrefilled: store.onboarding.businessDetail.mdrPackageId,
    mdrPackageDetailsPrefilled: store.onboarding.businessDetail.mdrPackageDetails,
    globalSearchString: store.onboarding.globalSearchString,
  }))
  const [fetchMdrPackageDetailsApi, fetchMdrPackageDetailsHandler] = useLazyApiData(fetchMdrPackageDetails)
  const [selectedFeePackageDetails, setSelectedFeePackageDetails] = useState('')
  const [mdrPackageDetails, setMdrPackageDetails] = useState('')
  const [isInheritFromParentFeePackage, setIsInheritFromParent] = useState(false)
  const [selectedMdrPackageId, setSelectedMdrPackageId] = useState('')
  const [isApiCalled, setIsApiCalled] = useState(false)

  useEffect(() => {
    if (
      inheritParentFeePackagePrefilled &&
      inheritParentFeePackagePrefilled.length > 0 &&
      mdrPackageIdPrefilled &&
      mdrPackageIdPrefilled.length > 0 &&
      mdrPackageDetailsPrefilled &&
      mdrPackageDetailsPrefilled?.length > 0 &&
      globalSearchString?.length === 0
    ) {
      setIsInheritFromParent(inheritParentFeePackagePrefilled === 'Yes')
      setSelectedMdrPackageId(mdrPackageIdPrefilled)
      setMdrPackageDetails(mdrPackageDetailsPrefilled)
      //maker checker flow
      if (mdrPackageIdPrefilled?.toString()?.length > 0 && mdrPackageIdPrefilled !== 'NA' && !isApiCalled) {
        fetchMdrPackageDetailsApi(mdrPackageIdPrefilled)
        setIsApiCalled(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fetchMdrPackageDetailsApi,
    globalSearchString?.length,
    inheritParentFeePackagePrefilled,
    isApiCalled,
    mdrPackageIdPrefilled,
    selectedFeePackageDetails,
  ])

  useEffect(() => {
    //create flow - parent as entity and inherit from parent is true
    if (emsParentEntityIdentificationNumber && isInheritFromParentFeePackage) {
      const parentData = parentFeePackageDetails(emsParentEntityIdentificationNumber)
      setMdrPackageDetails(parentData?.feePackageName)
      setSelectedMdrPackageId(parentData?.feePkgId)
      updateBusinessDetail('mdrPackageDetails', parentData?.feePackageName ?? '')
      updateBusinessDetail('mdrPackageId', parentData?.feePkgId ?? '')
      if (parentData && parentData?.feePkgId && !isApiCalled) {
        fetchMdrPackageDetailsApi(parentData?.feePkgId)
        setIsApiCalled(true)
      }
    }
    //Search case
    if (globalSearchString?.length > 0) {
      const parentData = parentFeePackageDetails(globalSearchString)
      setMdrPackageDetails(parentData?.feePackageName ?? 'NA')
      setSelectedMdrPackageId(parentData?.feePkgId ?? 'NA')
      updateBusinessDetail('mdrPackageDetails', parentData?.feePackageName ?? 'NA')
      updateBusinessDetail('mdrPackageId', parentData?.feePkgId ?? 'NA')
      if (parentData && parentData?.feePkgId && !isApiCalled) {
        fetchMdrPackageDetailsApi(parentData?.feePkgId)
        setIsApiCalled(true)
      }
    }
    updateBusinessDetail('inheritParentFeePackage', isInheritFromParentFeePackage ? 'Yes' : 'No')
  }, [
    emsParentEntityIdentificationNumber,
    parentFeePackageDetails,
    isInheritFromParentFeePackage,
    updateBusinessDetail,
    globalSearchString?.length,
    globalSearchString,
    fetchMdrPackageDetailsApi,
    isApiCalled,
  ])

  useEffect(() => {
    if (fetchMdrPackageDetailsHandler.state === 'fulfilled') {
      if (isInheritFromParentFeePackage) {
        const parentData = parentFeePackageDetails(emsParentEntityIdentificationNumber)
        if (fetchMdrPackageDetailsHandler?.data?.feePkgName?.length > 0) {
          setMdrPackageDetails(fetchMdrPackageDetailsHandler?.data?.feePkgName)
          updateBusinessDetail('mdrPackageDetails', fetchMdrPackageDetailsHandler?.data?.feePkgName)
          updateBusinessDetail('mdrPackageId', fetchMdrPackageDetailsHandler?.data?.feePkgId)
          setSelectedMdrPackageId(fetchMdrPackageDetailsHandler?.data?.feePkgId)
        }
        if (parentData?.feePkgId) {
          setSelectedMdrPackageId(parentData?.feePkgId)
          updateBusinessDetail('mdrPackageId', parentData?.feePkgId)
        }
      } else {
        if (selectedMdrPackageId?.toString()?.length > 0) {
          const data = getMdrList(fetchMdrPackageDetailsHandler.data)
          setSelectedFeePackageDetails(data)
          setSelectedMdrPackageId(selectedMdrPackageId)
          updateBusinessDetail('mdrPackageId', selectedMdrPackageId)
          updateBusinessDetail('mdrPackageDetails', data)
        }
      }
      updateBusinessDetail('inheritParentFeePackage', isInheritFromParentFeePackage ? 'Yes' : 'No')
    } else if (fetchMdrPackageDetailsHandler.state === 'rejected') {
      setMdrPackageDetails('')
      setSelectedMdrPackageId('')
      setSelectedFeePackageDetails('')
      updateBusinessDetail('mdrPackageDetails', '')
      updateBusinessDetail('mdrPackageId', '')
    }
  }, [
    emsParentEntityIdentificationNumber,
    fetchMdrPackageDetailsHandler,
    isInheritFromParentFeePackage,
    parentFeePackageDetails,
    selectedFeePackageDetails?.length,
    selectedMdrPackageId,
    updateBusinessDetail,
  ])

  useEffect(() => {
    if (fieldName && setFieldValue && selectedMdrPackageId?.toString()?.length > 0 && mdrPackageDetails?.length > 0) {
      setFieldValue(fieldName, {
        inheritParentFeePackage: isInheritFromParentFeePackage ? 'Yes' : 'No',
        mdrPackageId: selectedMdrPackageId,
        mdrPackageDetails: mdrPackageDetails,
      })
      console.log(
        '===> isInheritFromParentFeePackage, selectedMdrPackageId, mdrPackageDetails',
        isInheritFromParentFeePackage,
        selectedMdrPackageId,
        mdrPackageDetails,
      )
    }
  }, [
    fieldName,
    isInheritFromParentFeePackage,
    mdrPackageDetails,
    selectedMdrPackageId,
    setFieldValue,
    updateBusinessDetail,
  ])

  const onChangeMdrFeePkgId = (selectedData: any) => {
    setSelectedMdrPackageId(selectedData)
    updateBusinessDetail('mdrPackageId', selectedData)
    //On change from dropdown
    fetchMdrPackageDetailsApi(selectedData)
  }

  const onInheritFromParentChange = (dataType: any, checked: any) => {
    setSelectedFeePackageDetails('')
    setMdrPackageDetails('')
    setSelectedMdrPackageId('')
    setIsInheritFromParent(checked === 'Yes')
    updateBusinessDetail('inheritParentFeePackage', checked)
    if (mdrPackageDetailsPrefilled?.length === 0 || checked === 'No') {
      updateBusinessDetail('mdrPackageDetails', '')
    }
    if (mdrPackageIdPrefilled?.length === 0 || checked === 'No') {
      updateBusinessDetail('mdrPackageId', '')
    }
  }
  if (!showMdrFeePackage) {
    return null
  }
  return (
    <ModBox w={'100%'}>
      <ModBox
        show={isEdit}
        direction="row"
        alignItems={'center'}
        justifyContent={isParentSelectedIsEntity ? 'space-between' : 'flex-start'}>
        <ModBox minWidth={isParentSelectedIsEntity ? '24%' : undefined} show={isParentSelectedIsEntity}>
          <RadioButtonWithTitle
            {...styles.textinputStyle(isEdit)}
            direction={'horizontal'}
            color={'PRIMARY'}
            title={'Inherit Parent Fee Package?'}
            data={['Yes', 'No']}
            textSize={'SMALL'}
            selectedValue={isInheritFromParentFeePackage ? 'Yes' : 'No'}
            editable={isEdit}
            isFormElement={false}
            testID="inheritParentFeePackage"
            onChange={onInheritFromParentChange}
          />
        </ModBox>
        <Spacer size={16} />
        <ModBox minWidth={'24%'} show={!isInheritFromParentFeePackage}>
          <Dropdown
            label={'MDR Package ID'}
            placeholder={''}
            editable={!isInheritFromParentFeePackage}
            value={
              isInheritFromParentFeePackage && parentFeePackageDetails && parentFeePackageDetails?.id?.length > 0
                ? parentFeePackageDetails?.id?.toString()
                : selectedMdrPackageId?.toString()
            }
            data={getLovsFromKey('MDRPackageId')}
            {...styles.textinputStyle(isEdit)}
            testID="mdrPackageId"
            paddingHorizontal={8}
            title={'Select'}
            type={'default'}
            selectable={!isInheritFromParentFeePackage}
            selectedData={onChangeMdrFeePkgId}
          />
        </ModBox>
        <ModBox minWidth={'24%'} show={isInheritFromParentFeePackage} marginLeft={!isParentSelectedIsEntity ? 16 : 0}>
          <TextInputNew
            minWidth={'24%'}
            {...styles.textinputStyle(false)}
            label={'MDR Package ID'}
            editable={false}
            maxLength={4}
            type="body12"
            value={
              isInheritFromParentFeePackage && parentFeePackageDetails && parentFeePackageDetails?.id?.length > 0
                ? parentFeePackageDetails?.id
                : selectedMdrPackageId?.toString()?.length > 0
                ? selectedMdrPackageId
                : mdrPackageDetails
            }
            dataFieldToRead="description"
          />
        </ModBox>
        <Spacer size={16} />
        <ModBox minWidth={'24%'} show={!isInheritFromParentFeePackage} marginLeft={!isParentSelectedIsEntity ? 16 : 0}>
          <TextInputLabelToolTip
            minWidth={'24%'}
            {...styles.textinputStyle(isEdit)}
            label={'MDR Package Details'}
            placeholder={''}
            modalDetails={{
              data:
                isInheritFromParentFeePackage && mdrPackageDetails?.length > 0
                  ? mdrPackageDetails
                  : parentFeePackageDetails?.feePackageName?.length > 0
                  ? parentFeePackageDetails?.feePackageName
                  : selectedFeePackageDetails?.length > 0
                  ? selectedFeePackageDetails
                  : mdrPackageDetails,
            }}
            value={
              isInheritFromParentFeePackage && mdrPackageDetails?.length > 0
                ? mdrPackageDetails
                : parentFeePackageDetails?.feePackageName?.length > 0
                ? parentFeePackageDetails?.feePackageName
                : selectedFeePackageDetails?.length > 0
                ? selectedFeePackageDetails
                : mdrPackageDetails
            }
            color={'BLACK_21'}
            editable={false}
            testID={'mdrPackageDetails'}
            paddingHorizontal={8}
            multiline={true}
            numberOfLines={1}
          />
        </ModBox>
        <ModBox minWidth={'24%'} show={isInheritFromParentFeePackage}>
          <TextInputLabelToolTip
            minWidth={'24%'}
            {...styles.textinputStyle(false)}
            label={'MDR Package Details'}
            placeholder={''}
            modalDetails={{
              data:
                isInheritFromParentFeePackage && mdrPackageDetails?.length > 0
                  ? mdrPackageDetails
                  : parentFeePackageDetails?.feePackageName?.length > 0
                  ? parentFeePackageDetails?.feePackageName
                  : selectedFeePackageDetails?.length > 0
                  ? selectedFeePackageDetails
                  : mdrPackageDetails,
            }}
            value={
              isInheritFromParentFeePackage && mdrPackageDetails?.length > 0
                ? mdrPackageDetails
                : parentFeePackageDetails?.feePackageName?.length > 0
                ? parentFeePackageDetails?.feePackageName
                : selectedFeePackageDetails?.length > 0
                ? selectedFeePackageDetails
                : mdrPackageDetails
            }
            color={'BLACK_21'}
            editable={false}
            testID={'mdrPackageDetails'}
            paddingHorizontal={8}
            multiline={true}
            numberOfLines={1}
          />
        </ModBox>
        <Spacer size={16} />
        <ModBox minWidth={'24%'}>
          <Spacer size={'BIG'} />
        </ModBox>
      </ModBox>
      <ModBox show={!isEdit} direction="row" alignItems={'center'} justifyContent={'space-between'}>
        <TextInputNew
          minWidth={'24%'}
          {...styles.textinputStyle(isEdit)}
          label={'Inherit Parent Fee Package?'}
          editable={false}
          maxLength={4}
          type="body12"
          value={isInheritFromParentFeePackage ? 'Yes' : 'No'}
          dataFieldToRead="description"
        />
        <TextInputNew
          minWidth={'24%'}
          {...styles.textinputStyle(isEdit)}
          label={'MDR Package ID'}
          editable={false}
          maxLength={4}
          paddingHorizontal={isEdit ? 8 : undefined}
          type="body12"
          value={selectedMdrPackageId}
          dataFieldToRead="description"
        />
        <TextInputLabelToolTip
          minWidth={'24%'}
          {...styles.textinputStyle(isEdit)}
          label={'MDR Package Details'}
          placeholder={''}
          modalDetails={{
            data:
              isInheritFromParentFeePackage && mdrPackageDetails?.length > 0
                ? mdrPackageDetails
                : parentFeePackageDetails?.feePackageName?.length > 0
                ? parentFeePackageDetails?.feePackageName
                : selectedFeePackageDetails?.length > 0
                ? selectedFeePackageDetails
                : mdrPackageDetails,
          }}
          value={
            isInheritFromParentFeePackage && mdrPackageDetails?.length > 0
              ? mdrPackageDetails
              : parentFeePackageDetails?.feePackageName?.length > 0
              ? parentFeePackageDetails?.feePackageName
              : selectedFeePackageDetails?.length > 0
              ? selectedFeePackageDetails
              : mdrPackageDetails
          }
          color={'BLACK_21'}
          editable={false}
          testID={'mdrPackageDetails'}
          paddingHorizontal={8}
          multiline={true}
          numberOfLines={1}
        />
        <ModBox minWidth={'24%'}>
          <Spacer size={'BIG'} />
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export { FeePackageDetails }
